import { fabric } from 'fabric';

export async function imageObjectToDataURL(imageObject) {
  // for images within magic frames, the opacity must be forced to 1 because
  // the magic frame itself has hardcoded logic to display the image at 0.4 opacity in edit mode
  let opacity = imageObject.opacity;
  if (imageObject._magicFrame) {
    opacity = 1;
  }
  return new Promise((resolve) => {
    // Create a clone of the image with all properties preserved
    imageObject.clone((clonedImage) => {
      // Reset only the rotation
      clonedImage.angle = 0;
      clonedImage.scaleX = 1;
      clonedImage.scaleY = 1;
      clonedImage.opacity = opacity;
      // Create a temporary canvas to render the cloned image
      const tempCanvas = new fabric.StaticCanvas(null, {
        width: clonedImage.width * clonedImage.scaleX,
        height: clonedImage.height * clonedImage.scaleY,
      });
      // Add the cloned image to the canvas
      tempCanvas.add(clonedImage);
      tempCanvas.centerObject(clonedImage);
      tempCanvas.renderAll();
      resolve(
        tempCanvas.toDataURL({
          format: 'png',
          quality: 0.85,
          multiplier: 1,
          enableRetinaScaling: false,
        })
      );
    });
  });
}
